export const SectionTitleText = 'Detalhes do plano';
export const EmailText = 'E-mail';
export const VigencyText = 'Vigência: $$VIGENCY$$';
export const SaveAmountText = 'Você economiza ';